import React from 'react';
import Grid from '@mui/material/Grid';
import LoadingDialog from '../../Loading';
import { useNavigate, useLocation } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {
    InspectionContents,
    InspectionName,
    NomalButton,
    GrayButton,
    CautionButton
} from '../../css/CSS.js';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CheckIcon from '@mui/icons-material/Check';
import LowPriorityIcon from '@mui/icons-material/LowPriority';
import OperateForm from './OperateForm'
import DisplayForm from '../Warranty/DisplayForm'
import useAuthAxios from "../../../useAuthAxios";
import InspectionDeleteDialog from "../Warranty/InspectionDeleteDialog.js";
import InspectionPreviewDialog from "../Warranty/InspectionPreviewDialog";
import { getCookie } from "../../Action/HandleCookie"


const inspectionTheme = createTheme({
    palette: {
        background: {
            default: '#f8f7f6'
        }
    }
})


export default function CreatedForm() {
    const headers = { "Authorization": "Bearer " + localStorage.getItem("Auth") }
    const pathName = useLocation().pathname;
    const term = pathName.split("/").slice(-2)[0];
    const navigate = useNavigate();
    const authAxios = useAuthAxios();
    const [processing, setProcessing] = React.useState(false);
    const location = useLocation();
    const keyData = location.state.keyData;
    const editedData = {};
    const [inspectionPDFTitle, setInspectionPDFTitle] = React.useState("");
    const [inspectionPDF, setInspectionPDF] = React.useState();
    const [inspectionPDFErrorStatus, setInspectionPDFErrorStatus] = React.useState(false);
    const [posFile, setPosFile] = React.useState();
    const [latitude, setLatitude] = React.useState();
    const [mapLink, setMapLink] = React.useState(null);
    const [posFileStatus, setPosFileStatus] = React.useState(false);
    const [attachedFileList, setattachedFileList] = React.useState();
    const [attachedFiles, setAttachedFiles] = React.useState([]);
    const [attachedFileStatus, setAttachedFileStatus] = React.useState(false);
    const [previewImgIndex, setPreviewImgIndex] = React.useState(0)
    const [previewImgDialog, setPreviewImgDialog] = React.useState(false)

    const [previewPDFIndex, setPreviewPDFIndex] = React.useState(0)
    const [previewPDFDialog, setPreviewPDFDialog] = React.useState(false)

    const [prevDelIndex, setPrevDelIndex] = React.useState(0)
    const [previewImgDelDialog, setPreviewImgDelDialog] = React.useState(false)
    const [prevPDFDelIndex, setPrevPDFDelIndex] = React.useState(0)
    const [previewPDFDelDialog, setPreviewPDFDelDialog] = React.useState(false)


    React.useLayoutEffect(() => {
        if (!editedData || !keyData) {
            alert("訪問記録情報の取得に失敗しました。");
            navigate("/inspection/" + term + "/customerlist/reportlist");
        } else {
            setInspectionPDFTitle("訪問記録");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    React.useLayoutEffect(() => {
        if (processing === true) { return }
        setProcessing(true)

        //訪問記録PDF取得
        //setInspectionPDF(
        //    process.env.REACT_APP_API_URL
        //    + 'api/visitReport'
        //    + "/" + keyData.kojiCD
        //    + "/" + keyData.rptShubetsu
        //    + "/" + keyData.rptSeq
        //    + "?signType=1"
        //)
        authAxios
            .get('api/visitReport'
                + "/" + keyData.kojiCD
                + "/" + keyData.rptShubetsu
                + "/" + keyData.rptSeq
                + "?signType=1"
                , { headers }
            )
            .then(response => {
                if (response.status === 200) {
                    setInspectionPDF(
                        process.env.REACT_APP_API_URL
                        + 'api/visitReport'
                        + "/" + keyData.kojiCD
                        + "/" + keyData.rptShubetsu
                        + "/" + keyData.rptSeq
                        + "?signType=1"
                    )
                }
                setInspectionPDFErrorStatus(false)
                setProcessing(false)
            }).catch((error) => {
                if (error.response.status === 401) {
                    alert("認証情報が正しくありません。");
                    navigate("/");
                } else {
                    alert("訪問記録ファイルの取得に失敗しました。");
                    setInspectionPDFErrorStatus(true)
                }
                setProcessing(false)
            })


        //位置情報用添付ファイル取得
        authAxios
            .get('api/visitReport'
                + "/" + keyData.kojiCD
                + "/" + keyData.rptShubetsu
                + "/" + keyData.rptSeq
                + "/PosFile"
                , { headers }
            )
            .then(response => {
                if (response.status === 200) {
                    setPosFile(response.data);
                    if (response.data.latitude && response.data.longtitude) {
                        setLatitude(response.data.latitude + ", " + response.data.longtitude);
                        setMapLink('https://www.google.com/maps?q=' + response.data.longtitude + ', ' + response.data.latitude)
                        setPosFileStatus(true);
                    } else {
                        setLatitude(response.data.message);
                    }
                    if (response.data === "位置情報添付書類ファイル なし.") {
                        setPosFileStatus(false);

                    }
                    //添付ファイル一覧取得
                    authAxios
                        .get('api/visitReport'
                            + "/" + keyData.kojiCD
                            + "/" + keyData.rptShubetsu
                            + "/" + keyData.rptSeq
                            + "/attaches"
                            , { headers }
                        )
                        .then(response => {
                            if (response.status === 200) {
                                setattachedFileList(response.data.attachFileList);
                            }
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                alert("認証情報が正しくありません。");
                                navigate("/");
                            } else {
                                alert("添付ファイル一覧の取得に失敗しました。");
                            }
                        })
                }
                setProcessing(false)
            }).catch(() => {
                alert("表札・外観ファイルの取得に失敗しました。");
                setProcessing(false)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useLayoutEffect(() => {
        if (processing === true) { return }
        if (attachedFileStatus === false) { return }
        setProcessing(true)

        //添付ファイル一覧取得
        authAxios
            .get('api/visitReport'
                + "/" + keyData.kojiCD
                + "/" + keyData.rptShubetsu
                + "/" + keyData.rptSeq
                + "/attaches"
                , { headers }
            )
            .then(response => {
                if (response.status === 200) {
                    setattachedFileList(response.data.attachFileList);
                    setAttachedFileStatus(false);
                }
                setProcessing(false)
            }).catch((error) => {
                if (error.response.status === 401) {
                    alert("認証情報が正しくありません。");
                    navigate("/");
                } else {
                    alert("添付ファイル一覧の取得に失敗しました。");
                }
                setProcessing(false)
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attachedFileStatus]);

    React.useLayoutEffect(() => {
        if (processing === true) { return }
        setProcessing(true)

        const tempAttachedFiles = [];
        if (attachedFileList && attachedFileList.length !== 0) {
            for (let i = 0; i < attachedFileList.length; i++) {
                tempAttachedFiles.push({
                    ID: attachedFileList[i].fileId,
                    Name: attachedFileList[i].fileName,
                    src: 'api/visitReport'
                        + "/" + keyData.kojiCD
                        + "/" + keyData.rptShubetsu
                        + "/" + keyData.rptSeq
                        + "/" + attachedFileList[i].fileId
                        + "/" + attachedFileList[i].fileName,
                    fileType: attachedFileList[i].fileName.split('.').pop() === 'pdf' ? 'PDF' : 'Other',
                    fileShubetsu: attachedFileList[i].attachFileType
                })
            }
        }
        setAttachedFiles(tempAttachedFiles);
        setProcessing(false)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [attachedFileList]);

    React.useLayoutEffect(() => {
        if (processing === true) { return }
        setProcessing(true)

        authAxios
            .get('api/visitReport'
                + "/" + keyData.kojiCD
                + "/" + keyData.rptShubetsu
                + "/" + keyData.rptSeq
                + "/PosFile"
                , { headers }
            )
            .then(response => {
                if (response.status === 200) {
                    setPosFile(response.data);
                    if (response.data.latitude && response.data.longtitude) {
                        setLatitude(response.data.latitude + ", " + response.data.longtitude);
                        setMapLink('https://www.google.com/maps/search/?api=1&query=' + response.data.latitude + ', ' + response.data.longtitude)
                    } else {
                        setLatitude(response.data.message);
                    }

                    if (response.data === "") {
                        setPosFileStatus(false);
                        setLatitude("");
                    } else {
                        setPosFileStatus(true);
                    }
                }
                setProcessing(false)
            }).catch((error) => {
                if (error.response.status === 401) {
                    alert("認証情報が正しくありません。");
                    navigate("/");
                } else {
                    alert("表札・外観画像の取得に失敗しました。");
                }
                setProcessing(false)
            })
        setProcessing(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [posFileStatus]);

    //添付画像プレビュー非表示
    const previewImgCancelClick = () => {
        setPreviewImgDialog(false)
    }

    //添付PDFプレビュー別タブ表示
    React.useEffect(() => {
        if (previewPDFDialog === true) {
            window.open(process.env.REACT_APP_API_URL
                + 'api/visitReport/'
                + keyData.kojiCD
                + '/' + keyData.rptShubetsu
                + '/' + keyData.rptSeq
                + '/' + attachedFiles[previewPDFIndex].ID
                + '/' + attachedFiles[previewPDFIndex].Name
            )
            setPreviewPDFDialog(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [previewPDFDialog]);

    //添付画像削除プレビュー非表示
    const previewCancelBack = () => {
        setPreviewImgDelDialog(false)
        setPreviewPDFDelDialog(false)
    }

    //添付画像削除確定
    const previewImgDeleteConfirm = () => {
        setProcessing(true);
        authAxios
            .delete('api/visitReport/'
                + keyData.kojiCD
                + '/' + keyData.rptShubetsu
                + '/' + keyData.rptSeq
                + '/' + attachedFiles[prevDelIndex].ID
                + '/delete', { headers })
            .then(response => {
                if (response.status === 200) {
                    setAttachedFileStatus(true)
                    setPreviewImgDelDialog(false);
                    setProcessing(false);
                    setMapLink(null)
                }
            }).catch(response => {
                alert("添付ファイル取得に失敗しました。", response.body);
                setProcessing(false);
            })
    }

    //添付PDF削除確定
    const previewPDFDeleteConfirm = () => {
        setProcessing(true);
        authAxios
            .delete('api/visitReport/'
                + keyData.kojiCD
                + '/' + keyData.rptShubetsu
                + '/' + keyData.rptSeq
                + '/' + attachedFiles[prevPDFDelIndex].ID
                + '/delete', { headers })
            .then(response => {
                if (response.status === 200) {
                    setAttachedFileStatus(true)
                    setPreviewPDFDelDialog(false);
                    setProcessing(false);
                }
            }).catch(response => {
                alert("添付ファイル削除に失敗しました。", response.body);
                setProcessing(false);
            })
    }


    const onSubmit = (action) => {
        if (keyData.canEdit) {
            if ((action === "fix") || (action === "list")) {
                setProcessing(true);

                //添付ファイル数を更新
                authAxios
                    .get('api/visitReport/detail/' + keyData.kojiCD + "/" + keyData.rptShubetsu + '/' + keyData.rptSeq, { headers })
                    .then(response => {
                        if (response.status === 200) {
                            const formatData = JSON.parse((JSON.stringify(response.data)));
                            let getFormdata = null
                            getFormdata = formatData

                            if (getFormdata) {

                                let mergeData = JSON.parse(JSON.stringify(getFormdata))

                                //添付されたファイルをカウント
                                let fileCountBesshiRecord = 0
                                let fileCountBesshiZumen = 0
                                attachedFiles.forEach(attachedImageElement => {
                                    if (attachedImageElement.fileShubetsu === 0) {
                                        fileCountBesshiZumen++
                                    }
                                    if (attachedImageElement.fileShubetsu === 1) {
                                        fileCountBesshiRecord++
                                    }
                                })

                                mergeData.besshiRecordSheets = fileCountBesshiRecord.toString()
                                mergeData.besshiZumenSheets = fileCountBesshiZumen.toString()

                                setProcessing(true);
                                authAxios
                                    .post('api/visitReport/detail/' + keyData.kojiCD + '/' + keyData.rptShubetsu + '?inputType=1&reportSeqNo=' + keyData.rptSeq
                                        , mergeData)
                                    .then(response => {
                                        if (response.status === 200) {
                                            if (action === "fix") {
                                                authAxios
                                                    .post('api/visitReport/'
                                                        + keyData.kojiCD
                                                        + '/' + keyData.rptShubetsu
                                                        + '/' + keyData.rptSeq
                                                        + '/fix'
                                                        + '?comfirmStatus=1'
                                                        , { headers })
                                                    .then(response => {
                                                        if (response.status === 200) {
                                                            setProcessing(false);
                                                            redirectReportList();
                                                        }
                                                    }).catch((response) => {
                                                        alert("確定に失敗しました。", response.body);
                                                        setProcessing(false);
                                                    })
                                            } else {
                                                setProcessing(false);
                                                redirectReportList();
                                            }
                                        }
                                    }).catch((response) => {
                                        alert("作成中のデータの登録に失敗しました。", response.body);
                                        setProcessing(false);
                                    })

                            }

                        }
                    }).catch((response) => {
                        alert("データの取得に失敗しました。", response.body);
                        setProcessing(false);
                    })

            } else if (action === "cancel") {
                setProcessing(true);
                authAxios
                    .post('api/visitReport/'
                        + keyData.kojiCD
                        + '/' + keyData.rptShubetsu
                        + '/' + keyData.rptSeq
                        + '/fix'
                        + '?comfirmStatus=0'
                        , { headers })
                    .then(response => {
                        if (response.status === 200) {
                            setProcessing(false);
                            redirectReportList();
                        }
                    }).catch((response) => {
                        alert("確定解除に失敗しました。", response.body);
                        setProcessing(false);
                    })
            }
        } else if (keyData.canFix) {
            if (action === "fix") {
                setProcessing(true);
                authAxios
                    .post('api/visitReport/'
                        + keyData.kojiCD
                        + '/' + keyData.rptShubetsu
                        + '/' + keyData.rptSeq
                        + '/fix'
                        + '?comfirmStatus=1'
                        , { headers })
                    .then(response => {
                        if (response.status === 200) {
                            setProcessing(false);
                            redirectReportList();
                        }
                    }).catch((response) => {
                        alert("確定に失敗しました。", response.body);
                        setProcessing(false);
                    })
            } else if (action === "cancel") {
                setProcessing(true);
                authAxios
                    .post('api/visitReport/'
                        + keyData.kojiCD
                        + '/' + keyData.rptShubetsu
                        + '/' + keyData.rptSeq
                        + '/fix'
                        + '?comfirmStatus=0'
                        , { headers })
                    .then(response => {
                        if (response.status === 200) {
                            setProcessing(false);
                            redirectReportList();
                        }
                    }).catch((response) => {
                        alert("確定解除に失敗しました。", response.body);
                        setProcessing(false);
                    })
            } else {
                setProcessing(false);
                redirectReportList();
            }
        } else {
            redirectReportList();
        }
    };

    const redirectReportList = () => {
        setProcessing(true);
        authAxios
            .get('api/visitReport/visitReports/?kojiCD=' + keyData.kojiCD + '&customerCD=' + keyData.customer)
            .then(response => {
                if (response.status === 200) {
                    const listdata = JSON.parse((JSON.stringify(response.data)));
                    setProcessing(false);
                    navigate("/inspection/" + term + "/customerlist/reportlist", {
                        state:
                        {
                            listdata: listdata,
                            shiten: keyData.shiten,
                            koji: keyData.kojiCD,
                            teimei: keyData.teimei,
                            customer: keyData.customer,
                            canEdit: keyData.canEdit,
                            canFix: keyData.canFix,
                        }
                    });
                }
            }).catch((response) => {
                alert("訪問記録の取得に失敗しました。", response.body);
                setProcessing(false);
            })
    };

    return (
        <React.Fragment>
            <ThemeProvider theme={inspectionTheme}>
                <LoadingDialog load={processing} />
                <Grid style={{ position: "relative", }} >
                    <LoadingDialog load={false} />
                    <CssBaseline />
                    <AppBar sx={{ background: '#f8f7f6', boxShadow: 0, mt: '60px' }} >
                        <InspectionContents sx={{ mb: '2.5rem' }} maxWidth={false}>
                            <Grid container columns={12} spacing={3} sx={{ alignItems: 'flex-end' }}>
                                <Grid item xs={2.5} >
                                    <Typography sx={{ fontSize: '1.5rem', color: '#000000', mt: 3, mb: 1 }} >
                                        工事コード:{keyData.kojiCD}
                                    </Typography>
                                </Grid>
                                <Grid item xs={7} sx={{ pl: 1 }}>
                                    {keyData.thokiYuryoFlg === 1 ?
                                        <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                            <Typography sx={{ fontSize: '1.3rem', color: '#000000', mt: 3, mb: 1 }}>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        fontSize: "1.3rem",
                                                        fontWeight: 600,
                                                        mr: 1,
                                                        color: "#2e7d32",
                                                        backgroundColor: "transparent",

                                                        cursor: "default",
                                                        userSelect: "none",
                                                    }}>
                                                    【長期優良住宅】
                                                </Box>
                                                {keyData?.teimei}
                                            </Typography>
                                        </InspectionName>
                                        :
                                        <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                            <Typography sx={{ fontSize: '1.5rem', color: '#000000' }} >
                                                {keyData.teimei}
                                            </Typography>
                                        </InspectionName>
                                    }
                                </Grid>
                                {!keyData?.canEdit &&
                                    <Grid item xs={2.5} sx={{ pl: 1, justifyContent: "flex-end" }}>
                                        <InspectionName style={{ display: 'flex', paddingBottom: 0, justifyContent: 'center', }}>
                                            <Typography sx={{ fontSize: '1.3rem', color: '#000000' }}>
                                                読み取り専用
                                            </Typography>
                                        </InspectionName>
                                    </Grid>
                                }
                            </Grid>
                            <Grid container sx={{ justifyContent: "space-between", mt: 3 }}>
                                <GrayButton variant="contained" color="primary" size="large" type="button"
                                    sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }} onClick={() => onSubmit("list")}>
                                    <LowPriorityIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                    一覧へ
                                </GrayButton>

                                <Grid>
                                    {keyData.status !== 4 && keyData.canFix ?
                                        <NomalButton
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            type="button"
                                            sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }}
                                            onClick={() => onSubmit("fix")}
                                        >
                                            <CheckIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                            確定
                                        </NomalButton>
                                        : null
                                    }
                                    {keyData.status === 4 && keyData.canFix ?
                                        < CautionButton
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            type="button"
                                            sx={{ ml: 2, mr: 2, pt: 1.5, pb: 1.5, pl: 4, pr: 4, fontSize: '1.2rem' }}
                                            onClick={() => onSubmit("cancel")}
                                        >
                                            <CheckIcon sx={{ mr: 2, fontSize: '2rem' }} />
                                            確定解除
                                        </CautionButton>
                                        : null
                                    }
                                </Grid>
                            </Grid>
                        </InspectionContents>
                    </AppBar>
                    <Grid sx={{ height: '13rem' }} />
                    <InspectionContents sx={{ pt: 5, pb: 2 }} maxWidth={false}>
                        <Grid container >
                            <Grid item lg={5} md={5} >
                                <Grid item lg={12} md={12} maxWidth={false}>
                                    <OperateForm
                                        keyData={keyData}
                                        PDFTitle={inspectionPDFTitle}
                                        PDFFile={inspectionPDF}

                                        posStatus={posFileStatus}
                                        setPosStatus={setPosFileStatus}
                                        posData={posFile}
                                        setPosData={setPosFile}
                                        latitude={latitude}
                                        mapLink={mapLink}
                                        setMapLink={setMapLink}

                                        attachedFileStatus={attachedFileStatus}
                                        setAttachedFileStatus={setAttachedFileStatus}
                                        attachedData={attachedFiles}

                                        InspectionPreviewDialogOPEN={setPreviewImgDialog}
                                        PreviewImgIndex={setPreviewImgIndex}

                                        InspectionPreviewPDFDialogOPEN={setPreviewPDFDialog}
                                        PreviewPDFIndex={setPreviewPDFIndex}

                                        PrevDelIndex={setPrevDelIndex}
                                        PreviewImgDelDialog={setPreviewImgDelDialog}

                                        PrevPDFDelIndex={setPrevPDFDelIndex}
                                        PreviewPDFDelDialog={setPreviewPDFDelDialog}

                                    />
                                </Grid>
                                {previewImgDialog && (
                                    <InspectionPreviewDialog
                                        src={attachedFiles?.filter(item => item.fileType !== "PDF").map((list) => list.src)}
                                        index={previewImgIndex}
                                        open={previewImgDialog}
                                        cancelClick={previewImgCancelClick}
                                    />
                                )}
                                {previewImgDelDialog && (
                                    <InspectionDeleteDialog
                                        contentType={1}
                                        name={attachedFiles[prevDelIndex]?.Name}
                                        src={attachedFiles[prevDelIndex]?.src}
                                        open={previewImgDelDialog}
                                        cancelClick={previewCancelBack}
                                        deleteClick={previewImgDeleteConfirm}
                                    />
                                )}
                                {previewPDFDelDialog && (
                                    <InspectionDeleteDialog
                                        contentType={2}
                                        name={attachedFiles[prevPDFDelIndex]?.Name}
                                        open={previewPDFDelDialog}
                                        cancelClick={previewCancelBack}
                                        deleteClick={previewPDFDeleteConfirm}
                                    />
                                )}
                            </Grid>
                            <Grid item lg={7} md={7}
                                style={{
                                    marginLeft: 0,
                                    marginRight: 0
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'fixed',
                                        pt: 1
                                    }}
                                    style={{
                                        marginLeft: 0,
                                        marginRight: 0,
                                        width: '55%'
                                    }}
                                >
                                    <DisplayForm
                                        keyData={keyData}
                                        PDFTitle={inspectionPDFTitle}
                                        PDFFile={inspectionPDF}
                                        PDFErrorStatus={inspectionPDFErrorStatus}

                                        posStatus={posFileStatus}
                                        setPosStatus={setPosFileStatus}
                                        posData={posFile}
                                        setPosData={setPosFile}

                                        setAttachedFileStatus={setAttachedFileStatus}
                                        attachedData={attachedFiles}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </InspectionContents>
                </Grid>
            </ThemeProvider >
        </React.Fragment >
    );
}

